module.exports = __webpack_public_path__ + "img/customized_m.d0a96bba.jpg";